<ng-container *transloco="let t">
<!-- Button: binary toggle, the app only ever has English/Arabic -->
<button
    mat-icon-button
    (click)="toggleLanguage()"
    [matTooltip]="activeLang === 'ar' ? 'English' : 'العربية'"
    [attr.aria-label]="t('Change language')">
    <mat-icon [svgIcon]="'heroicons_outline:globe-alt'"></mat-icon>
</button>
</ng-container>
